import { createContext, useEffect, useState } from "react";
import { matchRoutes, useLocation, useNavigate } from "react-router-dom";

import AuthenticationModal from "components/AuthenticationModal";
import routes from "routes";
import { useIsUserBlocked } from "hooks/useIsUserBlocked";
import { ROUTE_PATHS } from "routes/paths";

const ALLOWED_PAGES = ["/help/:id", "/rules/:id", ROUTE_PATHS.not_permitted];

export const UserRestrictionsContext = createContext();

function UserRestrictionProvider({ children }) {
  const navigate = useNavigate();
  const isUserBlocked = useIsUserBlocked();
  const [authentication, setAuthentication] = useState(false);

  const location = useLocation();
  const routePatterns = matchRoutes(routes(), location);

  const handleUserRouteRestrictions = () => {
    const currentPage = routePatterns.find((route) =>
      ALLOWED_PAGES.includes(route.route.path)
    );

    if (isUserBlocked && !currentPage) {
      navigate(ROUTE_PATHS.not_permitted)
    }
  };

  useEffect(() => {
    if (isUserBlocked) {
      setAuthentication(true);
    }
  }, [isUserBlocked, navigate]);

  useEffect(() => {
    handleUserRouteRestrictions();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routePatterns]);

  return (
    <UserRestrictionsContext.Provider value={{}}>
      {children}

      {/* {authentication && (
        <AuthenticationModal
          open={authentication}
          onClose={() => setAuthentication(false)}
        />
      )} */}
    </UserRestrictionsContext.Provider>
  );
}

export default UserRestrictionProvider;
